import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

// ----------------------------------------------------------------------

export default function RHFAutocomplete({ name, label, placeholder, helperText, type = 'text', variant = 'outlined', ...other }) {
    const { control, setValue } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Autocomplete
                    {...field}
                    onChange={(event, newValue) => setValue(name, newValue, { shouldValidate: true })}
                    renderInput={(params) =>
                        <TextField
                            variant={variant}
                            type={type}
                            label={label}
                            hiddenLabel={!label}
                            placeholder={placeholder}
                            error={!!error}
                            helperText={error ? error?.message : helperText}
                            {...params}
                        />
                    }
                    {...other}
                />
            )}
        />
    );
}

RHFAutocomplete.propTypes = {
    helperText: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
};
